const options = {
      name: 'invoice',
      specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
      ],
      styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css'
      ]
    };
import Vue from 'vue';
import Heading from '@/components/pageheader_component.vue';
import moment from 'moment';
import 'moment-timezone';
import { mapGetters } from 'vuex';
import ClipboardEventsJS from "./handle_events_in_clipboard.js";
import html2pdf from 'html2pdf.js';
import VueHtmlToPaper from 'vue-html-to-paper';
Vue.use(VueHtmlToPaper,options);
export default {
    name: 'Invoice',
    components: {
        Heading
    },
    data() {
        return { 
            invoice_data : {},
            invoice_service_data : {},
            invoice_product_data : {},
            total_services_sum: 0,
            total_products_sum : 0,
            total_amount_paid_now : 0,
            total_deposit_amt : 0,
            total_discount : 0,
        }
    },
    async mounted(){
        await this.bookid_invoice();

        if (Object.entries(this.$store.state.bookings_data).length >0){
            await this.$store.dispatch('get_customer_details',[this.$store.state.api,[this.$store.state.bookings_data.bookings[0].cust_id,this.$store.state.bookings_data.bookings[0].owner_id]])
        }
    },
    computed: {
        ...mapGetters(["get_bookings_and_amount_data","get_services", "get_customers"])
    },  
    methods: {

        async  bookid_invoice(){
            this.$store.state.loader_popup = true;
            await this.$store.dispatch('get_booking_and_amount_details',[this.$store.state.api,this.$session.get('book_id'),this.$session.get('multi_book_id')]);
            this.invoice_data = this.$store.state.bookings_data;
          
            this.invoice_service_data =  this.$store.state.bookings_data.bookings;
            this.invoice_product_data =  this.$store.state.bookings_data.products;
            this.totalServiceAmount();

            this.$store.state.loader_popup = false;
        },

        rebook_date(weeks){
            var get_services    = this.invoice_service_data
            var get_customers   = this.get_customers.customer_details[0]
            var book_status     = this.invoice_service_data[0].book_status
            for (let service = 0; service < get_services.length; service++) 
            {
                var event_data = 
                {
                    id:get_services[service].book_id.toString(),
                    date:get_services[service].book_start_date,
                    vip:get_customers.is_vip,
                    allergy:get_customers.has_allergy,
                    fullpayment:get_customers.pay_fullpayment,
                    banned:get_customers.is_banned,
                    book_status:book_status,
                    name:get_customers.cust_first_name+' '+get_customers.cust_last_name,
                    start_time:get_services[service].book_start_time,
                    end_time:get_services[service].book_end_time,
                    service:get_services[service].serv_name,
                    booking_notes:get_services[service].book_staff_note,
                    last_visit_count:get_services[service].last_visited.length,
                    clipboard_event_flag:this.Constants.CLIPBOARD_EVENT_FROM_REBOOK
                }
                ClipboardEventsJS.create_clipboard_event(event_data)
            }
            this.$store.state.selected_date = moment(new Date(), 'dd-mm-yyyy').add(weeks*7, "days").format('YYYY-MM-DD');
            this.$router.push('/calendar');
        },

        totalServiceAmount(){
            this.invoice_service_data.forEach(serv => {
                this.total_amount_paid_now =   this.total_amount_paid_now + serv.paid_amount;
                this.total_deposit_amt = this.total_deposit_amt + serv.book_deposit;
                if(serv.book_discount_full_amount > 0){
                    this.total_discount = this.total_discount + serv.book_fullamount  - serv.book_discount_full_amount;
                    this.total_services_sum = this.total_services_sum + serv.book_discount_full_amount;
                }else{
                    this.total_services_sum = this.total_services_sum + serv.book_fullamount;
                }
            })

            if(Object.keys(this.invoice_product_data).length > 0){
                this.invoice_product_data.forEach(product => {
                    this.total_amount_paid_now =   this.total_amount_paid_now + product.paid_amount;
                    if(product.product_discount_full_amount > 0){

                        this.total_discount =  this.total_discount + ((product.product_full_amount - product.product_discount_full_amount) * product.product_quantity);

                        this.total_products_sum =  this.total_products_sum + product.product_discount_full_amount * product.product_quantity;
                    }else{
                        this.total_products_sum =  this.total_products_sum + product.product_full_amount * product.product_quantity;
                    }
                })
            }
            
            this.total_sum = this.total_services_sum + this.total_products_sum;
        },

        downloadPdf(){
            var nativeElement = document.getElementById('invoice-data');
            let options = {
                margin: 1,
                filename: 'invoice.pdf',
                html2canvas: { 
                  dpi: 192,
                  letterRendering: true, 
                  allowTaint: true, 
                  useCORS: true, 
                  logging: false, 
                  scrollX: 0,
                  scrollY: 0 
                },
                jsPDF: {
                  orientation: 'portrait',
                  unit: 'cm',
                  format: 'a4'
                }
            }; 
            html2pdf().set(options).from(nativeElement).save();
        },  
        print () {
            // Pass the element id here
            this.$htmlToPaper('invoice-data');
        }
    },
    filters:{
        date_head_format(date){
            return moment.utc(date).tz('Australia/Brisbane').format('hh:mm A, ddd, MMM D, YYYY');
        },
        date_format_aus(date){
            return moment.utc(date).tz('Australia/Brisbane').format('DD dddd, YYYY');
        },
        date_month_format_aus(date){
            return moment.utc(date).tz('Australia/Brisbane').format('dddd, D MMM, YYYY');
        },
        time_format_aus(time){
            return moment.utc(time, 'HH:mm:ss').tz('Australia/Brisbane').format('hh:mm A');
        },
        // JOYWEB-2800: plain (wall-clock) variant of date_month_format_aus. book_start/end_date
        // are already stored as Brisbane wall-clock, so they must NOT be re-interpreted as UTC and
        // shifted +10h (which printed the completed date/time on the wrong day). Use for those fields.
        date_month_format(date){
            return moment(date).format('dddd, D MMM, YYYY');
        },
        date_format(date){
            return moment(date).format('ddd, MMM D, YYYY');
        },
        time_format(time){
            return moment(time, 'HH:mm:ss').format('hh:mm A');
        }
    }
}